// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { implicitReturnType } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    limitlessPublicGetMarketsActive (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsActiveCategoryId (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetCategories (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsAddressOrSlug (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsCategoriesCount (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsActiveSlugs (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSearch (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSlugOrderbook (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSlugHistoricalPrice (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetAuthSigningMessage (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsAddressOrSlugOracleCandles (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSlugGetFeedEvents (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSlugEvents (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsTimeline (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketsSlugTimeline (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetNavigation (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketPagesByPath (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetMarketPagesIdMarkets (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPropertyKeys (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPropertyKeysId (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPropertyKeysIdOptions (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPortfolioAccountTradedVolume (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPortfolioAccountPositions (params?: {}): Promise<implicitReturnType>;
    limitlessPublicGetPortfolioAccountPnlChart (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetAuthApiKeys (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetProfilesPartnerAccounts (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetMarketsSlugUserOrders (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioPositions (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioTrades (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetMarketsSlugLockedBalance (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetProfilesMe (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetProfilesAccount (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioPnlChart (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioHistory (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioPoints (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetPortfolioTradingAllowance (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetAuthApiTokensCapabilities (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetAuthApiTokens (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateGetProfilesPartnerAccountsProfileIdAllowances (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostAuthLogout (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostAuthApiKeys (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostAuthLogin (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostOrders (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostOrdersCancel (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostOrdersCancelBatch (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostOrdersBatchCancel (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostOrdersStatusBatch (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostPortfolioRedeem (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostPortfolioWithdraw (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostPortfolioWithdrawalAddresses (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostAuthApiTokensDerive (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostProfilesPartnerAccounts (params?: {}): Promise<implicitReturnType>;
    limitlessPrivatePostProfilesPartnerAccountsProfileIdAllowancesRetry (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateDeleteAuthApiKeys (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateDeleteOrdersOrderId (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateDeleteOrdersAllSlug (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateDeleteAuthApiTokensTokenId (params?: {}): Promise<implicitReturnType>;
    limitlessPrivateDeletePortfolioWithdrawalAddressesAddress (params?: {}): Promise<implicitReturnType>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
